import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

function CreditScore() {
  const colorPalette = ["#FF784B", "#2DD4BF", "#1E90FF"];
  const [state] = useState({
    series: [
      {
        name: "Experian",
        data: [450, 500, 570, 575, 600, 600, 620, 673, 675, 720, 750],
      },
      {
        name: "Equifax",
        data: [400, 510, 530, 549, 615, 616, 647, 658, 688, 730, 760],
      },
      {
        name: "TransUnion",
        data: [500, 520, 563, 569, 620, 620, 633, 640, 683, 703, 763],
      },
    ],
    options: {
      chart: {
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      title: {
        text: "Track Your Progress",
        align: "left",
        style: {
          fontSize: "18px",
          fontWeight: "bold",
        },
      },
      stroke: {
        show: true,
        width: 2,
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        line: {
          markers: {
            size: 5,
          },
        },
      },
      yaxis: {
        title: false,
        style: {
          fontSize: "12px",
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        crosshairs: {
          show: true,
        },
      },
      colors: colorPalette,
      fill: {
        colors: colorPalette,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " points";
          },
        },
      },
      grid: {
        show: false, // Hide grid lines
      },
      legend: {
        show: true,
        position: "top",
      },
    },
  });

  return (
    <ReactApexChart
      options={state.options}
      series={state.series}
      height={350}
    />
  );
}

export default CreditScore;
